/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingWalletType } from './BillingWalletType';
import {
    BillingWalletTypeFromJSON,
    BillingWalletTypeFromJSONTyped,
    BillingWalletTypeToJSON,
    BillingWalletTypeToJSONTyped,
} from './BillingWalletType';
import type { BillingProductPrice1 } from './BillingProductPrice1';
import {
    BillingProductPrice1FromJSON,
    BillingProductPrice1FromJSONTyped,
    BillingProductPrice1ToJSON,
    BillingProductPrice1ToJSONTyped,
} from './BillingProductPrice1';

/**
 * 
 * @export
 * @interface BillingWallet
 */
export interface BillingWallet {
    /**
     * 
     * @type {number}
     * @memberof BillingWallet
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof BillingWallet
     */
    billingWalletTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof BillingWallet
     */
    billingProductPriceId: number | null;
    /**
     * 
     * @type {string}
     * @memberof BillingWallet
     */
    status: BillingWalletStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BillingWallet
     */
    balance: number;
    /**
     * 
     * @type {number}
     * @memberof BillingWallet
     */
    balanceIncludingPending: number;
    /**
     * 
     * @type {number}
     * @memberof BillingWallet
     */
    balanceRefreshThreshold: number | null;
    /**
     * 
     * @type {Date}
     * @memberof BillingWallet
     */
    lastProjectedAt: Date;
    /**
     * 
     * @type {BillingWalletType}
     * @memberof BillingWallet
     */
    billingWalletType: BillingWalletType;
    /**
     * 
     * @type {BillingProductPrice1}
     * @memberof BillingWallet
     */
    billingProductPrice: BillingProductPrice1 | null;
}

/**
* @export
* @enum {string}
*/
export enum BillingWalletStatusEnum {
    Active = 'Active',
    Arrears = 'Arrears',
    Paused = 'Paused',
    Suspended = 'Suspended'
}


/**
 * Check if a given object implements the BillingWallet interface.
 */
export function instanceOfBillingWallet(value: object): value is BillingWallet {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('billingWalletTypeId' in value) || value['billingWalletTypeId'] === undefined) return false;
    if (!('billingProductPriceId' in value) || value['billingProductPriceId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('balance' in value) || value['balance'] === undefined) return false;
    if (!('balanceIncludingPending' in value) || value['balanceIncludingPending'] === undefined) return false;
    if (!('balanceRefreshThreshold' in value) || value['balanceRefreshThreshold'] === undefined) return false;
    if (!('lastProjectedAt' in value) || value['lastProjectedAt'] === undefined) return false;
    if (!('billingWalletType' in value) || value['billingWalletType'] === undefined) return false;
    if (!('billingProductPrice' in value) || value['billingProductPrice'] === undefined) return false;
    return true;
}

export function BillingWalletFromJSON(json: any): BillingWallet {
    return BillingWalletFromJSONTyped(json, false);
}

export function BillingWalletFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingWallet {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'billingWalletTypeId': json['billingWalletTypeId'],
        'billingProductPriceId': json['billingProductPriceId'],
        'status': json['status'],
        'balance': json['balance'],
        'balanceIncludingPending': json['balanceIncludingPending'],
        'balanceRefreshThreshold': json['balanceRefreshThreshold'],
        'lastProjectedAt': (new Date(json['lastProjectedAt'])),
        'billingWalletType': BillingWalletTypeFromJSON(json['billingWalletType']),
        'billingProductPrice': BillingProductPrice1FromJSON(json['billingProductPrice']),
    };
}

  export function BillingWalletToJSON(json: any): BillingWallet {
      return BillingWalletToJSONTyped(json, false);
  }

  export function BillingWalletToJSONTyped(value?: BillingWallet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billingWalletTypeId': value['billingWalletTypeId'],
        'billingProductPriceId': value['billingProductPriceId'],
        'status': value['status'],
        'balance': value['balance'],
        'balanceIncludingPending': value['balanceIncludingPending'],
        'balanceRefreshThreshold': value['balanceRefreshThreshold'],
        'lastProjectedAt': ((value['lastProjectedAt']).toISOString()),
        'billingWalletType': BillingWalletTypeToJSON(value['billingWalletType']),
        'billingProductPrice': BillingProductPrice1ToJSON(value['billingProductPrice']),
    };
}

